import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { z } from 'zod';
import en from 'zod/v4/locales/en.js';
import zhCN from 'zod/v4/locales/zh-CN.js';
import { locale } from './lib/i18n';
import './lib/format';
import { createRouter } from './router';
import { AppSettingsProvider } from './theme/app-settings';
import { ThemeProvider } from './theme/theme-provider';
import './styles/global.css';

z.config(locale === 'en-US' ? en() : zhCN());

const container = document.getElementById('root');
if (container === null) {
  // index.html owns this element; without it there is nothing to mount and no useful
  // fallback, so failing loudly beats rendering a blank page.
  throw new Error('未找到 #root 容器，请检查 index.html');
}

/**
 * The router is created once, outside React.
 *
 * It carries the query client in its context so route guards can `await` cached data in
 * `beforeLoad` — that is what makes "redirect to the login page" happen before a
 * protected screen renders rather than one frame after it.
 */
const router = createRouter();
const queryClient = router.options.context.queryClient;

createRoot(container).render(
  <StrictMode>
    <AppSettingsProvider>
      {/* ThemeProvider owns antd's modal host, which also needs query context. */}
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </AppSettingsProvider>
  </StrictMode>,
);
